import { ApiGetSystem, ApiUpdateSystem } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function SystemService() {
    const { showFail } = useModal()

    const { fetch: apiGetSystem } = useFetch(ApiGetSystem)
    const { fetch: apiUpdateSystem } = useFetch(ApiUpdateSystem)

    const fetchSystem = async(systemKey) => {
        const res = await apiGetSystem({
            data: {
                systemKey
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateSystem = async (systemKey, systemValue, systemLabel) => {
        const res = await apiUpdateSystem({
            data: {
                systemKey,
                systemValue,
                systemLabel
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchSystem,
        fetchUpdateSystem
    }
}